module.exports = __webpack_public_path__ + "static/media/project2_poster.aee03a14.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/project2_poster.png
// module id = 360
// module chunks = 0